module.exports = __webpack_public_path__ + "static/media/cristalero.1068f72e.png";